// @flow
import * as ActionTypes from '../../constants/ActionTypes';

export const adminGetSystemUsage = () => ({
  type: ActionTypes.ADMIN_GET_SYSTEM_USAGE_START,
});

export const adminGetSystemUsageSuccess = (data) => {
  return {
    type: ActionTypes.ADMIN_GET_SYSTEM_USAGE_SUCCESS,
    payload: data,
  };
};

export const adminGetSystemUsageFailure = (error) => ({
  type: ActionTypes.ADMIN_GET_SYSTEM_USAGE_FAILURE,
  payload: error,
});
